module.exports = __webpack_public_path__ + "static/media/SubmittedFive.cc8b4c18.png";